import { ComponentType, lazy } from "react";

const key = "pinwheel-error-reloaded";

// Check if error is a dynamic import failure
const isDynamicImportError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  
  // Check for various dynamic import failure patterns
  return (
    error.name === "ChunkLoadError" ||
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Loading chunk") ||
    error.message.includes("Loading CSS chunk") ||
    error.message.includes("Unable to preload CSS") ||
    error.message.includes("ChunkLoadError")
  );
};

// Need this any as it breaks some of the component imports if we use unknown.  Too much time to figure out why
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyWithErrorHandling = <T extends ComponentType<any>>(load: () => Promise<{ default: T }>) =>  {
  return lazy(async () => {
    const sessionStorage = window.sessionStorage;
    
    try {
      const result = await load();
      sessionStorage.removeItem(key);
      return result;
    } catch (error: unknown) {
      console.warn("Dynamic import failed:", error);
      
      if (isDynamicImportError(error) && sessionStorage.getItem(key) !== "true") {
        console.warn("Reloading page due to chunk load failure...");
        sessionStorage.setItem(key, "true");
        window.location.reload();
      }
      throw error;
    }
  });
}